<template>
<div class="skills">
    <div class="container">
        <div v-if="content">
            <h2  ref="skillsTitle" >{{ content.titre }}</h2>
        <div  ref="skillsContent" class="skills__content" v-html="content.texte"></div>
        </div>
    </div>
</div>
</template>

<script setup lang="ts">
import type { SavoirFaire } from '~/types/options';

const skillsTitle = useAnimateOnVisible('animate__fadeIn')
const skillsContent = useAnimateOnVisible('animate__fadeIn')

    const props = defineProps<{
        content?:SavoirFaire
    }>()

</script>

<style lang="scss">
    .skills{
        background-color: $violet_light;
        padding: 50px 0;
        position: relative;
        z-index: 4;
        @media screen and (max-width:1035px) {
            padding:25px 0;
        }
        h2{
            margin-top: 0;
            opacity: 0;
        }
        &__content {
            max-width: 1000px;
            margin: auto;
            position: relative;
            opacity: 0;
            @media screen and (max-width:1035px) {
                        max-width: 90%;
                    }
            &:before{
                content: '';
                width: 75px;
                height: 65px;
                 background-image: url('~/assets/svgs/shape-4.svg');
                 background-repeat: no-repeat;
                 background-size: contain;
                 position: absolute;
                top: -50px !important;
                left: -20px !important;
                 transform: scale(0);
                opacity: 0;
                animation: enterScale 0.6s ease-out 0.2s forwards;
                @media screen and (max-width:1035px){
                    width: 50px;
                    height: 40px;
                    top: -30px !important;
                    left: -30px !important;
                }
            }
            p{
                max-width: 900px;
                color: $text;
                font-size: 20px;
                line-height: 26px;
                font-weight: 600;
                text-align: center;
                margin: 0 auto;
                @media screen and (max-width:1035px) {
                    font-size: 16px;
                    line-height: 20px; 
                }
            }
        }
    }
        @keyframes enterScale {
            0% {
                transform: scale(0);
                opacity: 0;
            }
            100% {
                transform: scale(1);
                opacity: 1;
                top: -75px;
                left:-75px;
            }
}
</style>
